<h1 data-testid="cart-heading" i18n>Warenkorb</h1>

@if (cart?.cartPositions.length <= 0) {
  <div i18n>Ihr Warenkorb ist leer</div>
}



@if (cart?.cartPositions.length > 0) {
  <div class="row">
    <div class="col-sm-8">
      <div>
        @for (cartPosition of cart.cartPositions; track cartPosition) {
          <div>
            <app-cart-item
              [cartItem]="cartPosition"
              [orderError]="positionErrors[cartPosition.skuId]"
            ></app-cart-item>
          </div>
        }
      </div>
    </div>
    <div class="col-sm-4">
      <div class="card cardMeasurements">
        <div class="card-body">
          <div>
            <h6 i18n>Zwischensumme:</h6>
            <h3>{{ cart?.totalGrossPrice | currency: cart?.currency }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      @if (cart?.isCheckoutPending) {
        <div class="alert alert-warning" role="alert" i18n>
          Für diesen Warenkorb läuft bereits ein Checkout. Bitte warten Sie, bis er abgeschlossen ist.
        </div>
      }
      <button
        class="btn btn-primary btn-lg"
        type="button"
        data-testid="cart-checkout-button"
        [asyncClick]="checkout.bind(this)"
        [disabled]="checkoutBtn.disabled || cart?.isCheckoutPending"
        #checkoutBtn="asyncClick"
        >
        @if (checkoutBtn.busy) {
          <span i18n>Wird verarbeitet …</span>
        } @else {
          <span i18n>Jetzt kaufen</span>
        }
      </button>
    </div>
  </div>
}
